import TargetMatcher from "../../match/TargetMatcher"
import ActionResolver from "../../action/ActionResolver"
import Bucketer from "../../bucket/Bucketer"
import EvaluationFlow from "../../flow/EvaluationFlow"
import {
  CompletedEvaluator,
  ContainerEvaluator,
  DefaultRuleEvaluator,
  DraftEvaluator,
  ExperimentFlow,
  ExperimentTargetEvaluator,
  IdentifierEvaluator,
  OverrideEvaluator,
  PausedEvaluator,
  TargetRuleEvaluator,
  TrafficAllocateEvaluator
} from "./ExperimentFlowEvaluator"
import ExperimentTargetDeterminer from "../../target/ExperimentTargetDeterminer"
import TargetRuleDeterminer from "../../target/TargetRuleDeterminer"
import { ExperimentType } from "../../../model/model"
import OverrideResolver from "../../target/OverrideResolver"
import ContainerResolver from "../../container/ContainerResolver"
import { ManualOverrideStorage } from "../../target/ManualOverrideStorage"

export default class ExperimentFlowFactory {
  private readonly abTestFlow: ExperimentFlow
  private readonly featureFlagFlow: ExperimentFlow

  constructor(manualOverrideStorage: ManualOverrideStorage, bucketer: Bucketer, targetMatcher: TargetMatcher) {
    const actionResolver = new ActionResolver(bucketer)
    const overrideResolver = new OverrideResolver(manualOverrideStorage, targetMatcher, actionResolver)
    const containerResolver = new ContainerResolver(bucketer)

    this.abTestFlow = EvaluationFlow.of(
      new OverrideEvaluator(overrideResolver),
      new IdentifierEvaluator(),
      new ContainerEvaluator(containerResolver),
      new ExperimentTargetEvaluator(new ExperimentTargetDeterminer(targetMatcher)),
      new DraftEvaluator(),
      new PausedEvaluator(),
      new CompletedEvaluator(),
      new TrafficAllocateEvaluator(actionResolver)
    )

    this.featureFlagFlow = EvaluationFlow.of(
      new DraftEvaluator(),
      new PausedEvaluator(),
      new CompletedEvaluator(),
      new OverrideEvaluator(overrideResolver),
      new IdentifierEvaluator(),
      new TargetRuleEvaluator(new TargetRuleDeterminer(targetMatcher), actionResolver),
      new DefaultRuleEvaluator(actionResolver)
    )
  }

  getExperimentFlow(experimentType: ExperimentType): ExperimentFlow {
    switch (experimentType) {
      case "AB_TEST":
        return this.abTestFlow
      case "FEATURE_FLAG":
        return this.featureFlagFlow
    }
  }
}
